<template>
  <div>
    <div class="g-header">
      <div class="brand">
        <router-link class="brand-logo" :to="{ path: '/' }">
          <img src="./logo.png" alt="造物商城" />
        </router-link>
      </div>
      <button class="nav-toggle c-icon-menu" @click="btnClick"></button>
    </div>
    <!-- <div class="noticeWindow" v-if="noticeWindow">
    <div class="windowContent">
      <div class="imgContent">
        <h6>尊敬的客户：</h6>
        <p>您好，值此2020年新春之际，造物云全体同仁再次给您拜年，祝您健康平安！</p>
        <p>2020年的春节注定是一个不寻常的春节。新型冠状病毒疫情蔓延至大江南北，牵动着每一位中国人的心，全国面对着一场与时间赛跑的防疫阻击战。</p>
        <p>作为医疗物资核心供应商配套企业，金百泽工厂于<span>2月6日</span>已实现PCB、IEMS生产线的复工，线上平台造物云、销售及其他职能部门已返岗积极战“疫”，
        全线支持医疗设备、体温检测仪等核心部件所需PCB及电子元器件的生产，火速驰援疫区，与国家与人民一起向病毒宣战，为武汉加油！为中国加油！</p>
        <p>为响应保证医疗行业客户订单需求，造物云<span>2月6日-2月9日</span>只接入医疗客户生产订单，其余行业客户订单将于<span>2月10日</span>起安排。特殊时期，非常感谢您的理解与支持！
        同担当，共进退，我们与您一起战“疫”！</p>
      </div>

      <img src="./close.svg"  class="closeWindow" @click="closeWindow">
    </div>
</div> -->
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    hasBack: {
      type: Boolean,
      default: false
    },
    hasSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      noticeWindow: true
    }
  },
  mounted(){
    // var value = sessionStorage.getItem('noticeWindow');
    // if (value){
    //   this.noticeWindow = false
    // }
  },
  methods: {
    btnClick(){
      this.$emit('showmask');
    }
    // closeWindow(){
    //   this.noticeWindow = false;
    //   sessionStorage.setItem("noticeWindow", "is")
    // }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import "~assets/scss/compile";
@import "./header";
</style>



// WEBPACK FOOTER //
// src/components/common/header/header.vue